import Resource from '@/api/Resource';
import Task from '@/models/Task';
import Server from '@/models/Server';

const statuses = [
  { name: 'Отключена', color: 'is-danger', icon: 'close-circle' },
  { name: 'Активна', color: 'is-success', icon: 'check-circle' },
  { name: 'Тестирование', color: 'is-dark', icon: 'flash-circle' },
];

export default class extends Resource {
  $name = 'platforms';

  $defaults() {
    return {
      id: null,
      status: 1,
      priority: 0,
      label_id: 0,
      server_id: 0,
      name: '',
      company: '',
      key: '',
      api_key: '',
      host: '',
      tariff_users: null,
      contract_date: null,
      contract_pay_date: null,
      created_at: null,
      updated_at: null,
      info: null,
    };
  }

  $fill({ tasks, server }) {
    if (tasks) {
      this.tasks = Task.collection(tasks);
    }
    if (server) {
      this.server = new Server(server);
    }
  }

  get statusList() {
    return statuses;
  }

  get statusLabel() {
    return statuses[this.status] || { name: 'Unknown' };
  }

  get labelColor() {
    return this.label ? this.label.color : 'is-grey';
  }

  get isActiveServer() {
    return this.server && this.server.status === 'active';
  }

  // get infoObjectsTotal() {
  //   return this.getInfoValue('objects', 'total');
  // }

  // get infoUsersActive() {
  //   return this.getInfoValue('users', 'active');
  // }
  // get infoUsersWorking() {
  //   return this.getInfoValue('users', 'working');
  // }
  // get infoUsersOnline() {
  //   return this.getInfoValue('users', 'online');
  // }

  getInfoValue(group, property) {
    if (this.info && this.info[group] && this.info[group].data[property]) {
      return this.info[group].data[property].value;
    }
    return null;
  }

  getUrl() {
    return `https://${this.host}`;
  }

  $pullPlatformStat() {
    if (this.id) {
      return this.$api('read', `${this.id}/pullPlatformStat`);
    }
  }
}
